import React from 'react';
import PropTypes from 'prop-types';

const PlayerInfo = props => {

    const { name, info } = props.playerInfo;

    return (
        <section className="mt-0 mt-md-4 mb-2 mb-md-4">
            <h1 className="mb-0 mt-0 mt-md-3 player-name">{name}</h1>
            <ul className="list-unstyled">
                {
                    info.map((inf, i) => {
                        return <li className="border-top border-dark" key={i}>
                            <span className="player-data-subtitle">{inf.key}: </span>
                            <span className="player-data-item">{inf.value}</span>
                        </li>
                    })
                }
            </ul>
        </section>
    )
}

export default PlayerInfo;

PlayerInfo.propTypes = {
    playerInfo: PropTypes.object.isRequired
}
